import { navigate } from '../router.js';
import { PageHead } from '../ui.js';
import { useT } from '../i18n.js';

/** UX-1060 "Not available yet" for a module that is off for the role; also "Not for your role" and "Page not found". */
export function NotAvailable(p: { message: string; title: string; heading?: string }) {
  const t = useT();
  return (
    <div class="screen screen--narrow">
      <PageHead title={p.title} />
      <div class="empty">
        <h2 class="blk-title">{p.heading ?? t.gate.notYet}</h2>
        <p>{p.message}</p>
        <button type="button" class="btn btn-primary" onClick={() => navigate('/')}>
          {t.gate.goHome}
        </button>
      </div>
    </div>
  );
}
